import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShortcutArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.72394 3.33333C7.02264 3.33333 7.1905 3.67703 7.00687 3.9126L5.07459 6.39141C4.93097 6.57565 4.65237 6.57565 4.50875 6.39141L2.57647 3.9126C2.39283 3.67703 2.5607 3.33333 2.85939 3.33333L6.72394 3.33333Z",
		fill: "currentColor"
	})
});
export default SvgShortcutArrow;
